import React from 'react';
import {Outlet} from "react-router-dom";

const layout = () => {
    return <Outlet/>
}

export default layout;